import { Navigate, Route, Routes, useMatch } from "react-router-dom"

import { useGetEnabledModulesInApp } from "@l2r-front/l2r-networks"
import { BottomSheetMobileLayout } from "@l2r-front/l2r-ui"

import { EquipmentFilterButton } from "../../../modules/equipment/containers/EquipmentFilterButton"
import { EquipmentMapLayersRouter } from "../../../modules/equipment/routers/EquipmentMapLayersRouter"
import { EquipmentMobileRoutes } from "../../../modules/equipment/routers/EquipmentRoutes"
import { TAGS_FILTER } from "../../../modules/horizontalSigning/constants/filters"
import { HorizontalSigningFilterButton } from "../../../modules/horizontalSigning/containers/HorizontalSigningFilterButton"
import { HorizontalSigningMapLayersRouter } from "../../../modules/horizontalSigning/routers/HorizontalSigningMapLayersRouter"
import { HorizontalSigningMobileRoutes } from "../../../modules/horizontalSigning/routers/HorizontalSigningRoutes"
import { VerticalSigningFilterButton } from "../../../modules/verticalSigning/containers/VerticalSigningFilterButton"
import { VerticalSigningMapLayersRouter } from "../../../modules/verticalSigning/routers/VerticalSigningMapLayersRouter"
import { VerticalSigningMobileRoutes } from "../../../modules/verticalSigning/routers/VerticalSigningRoutes/VerticalSigningMobileRoutes"
import { appCity } from "../../constants/appCity"
import { MODULE_EQUIPMENT, MODULE_HORIZONTAL_SIGNING, MODULE_VERTICAL_SIGNING } from "../../constants/modules"
import { Map } from "../../containers/Map"

export function CityMobileRouter() {

    const enabledCityModule = useGetEnabledModulesInApp(appCity)
    const matchDetailView = useMatch(":networkId/:appId/:moduleId/:road/:detailId/*")
    const matchDetailCodeView = useMatch(":networkId/:appId/:moduleId/:road/code/:codeId/:detailId/*")
    const isDetailView = matchDetailCodeView || matchDetailView && matchDetailView.params.road !== "code" && matchDetailView.params.detailId !== "code"

    return (
        <Routes>
            <Route
                path={`/${MODULE_VERTICAL_SIGNING}/*`}
                element={<BottomSheetMobileLayout
                    BottomSheetRouter={VerticalSigningMobileRoutes}
                    MapComponent={Map}
                    mapProps={{ bottomRightElements: !isDetailView && [<VerticalSigningFilterButton key="vertical-signing-filter-button" enabledFilters={[TAGS_FILTER]} />] }}
                    MapRouter={VerticalSigningMapLayersRouter}
                />}
            />
            <Route
                path={`/${MODULE_HORIZONTAL_SIGNING}/*`}
                element={<BottomSheetMobileLayout
                    BottomSheetRouter={HorizontalSigningMobileRoutes}
                    MapComponent={Map}
                    mapProps={{ bottomRightElements: !isDetailView && [<HorizontalSigningFilterButton key="horizontal-signing-filter-button" enabledFilters={[TAGS_FILTER]} />] }}
                    MapRouter={HorizontalSigningMapLayersRouter}
                />}
            />
            <Route
                path={`/${MODULE_EQUIPMENT}/*`}
                element={<BottomSheetMobileLayout
                    BottomSheetRouter={EquipmentMobileRoutes}
                    MapComponent={Map}
                    mapProps={{ bottomRightElements: !isDetailView && [<EquipmentFilterButton key="equipment-filter-button" enabledFilters={[TAGS_FILTER]} />] }}
                    MapRouter={EquipmentMapLayersRouter}
                />}
            />
            <Route
                path="/*"
                element={<Navigate replace to={enabledCityModule?.[0]?.path || ""} />}
            />
        </Routes>
    )
}
